<template>
<div class="lay">
    <div class="forca_parte">
          <h1>F<img class="imagem" src="/jogo-da-forca/images/brain.png" />rca</h1>
    </div>
    <div class="jogo">
        <Forca :erros="erros"/>
        <Palavra :palavra="palavra" :dica="dica" :verificarLetra="verificarLetra" :etapa="etapa"/>
        <Teclado v-if="etapa === 'jogo' " :letras="letras" :verificarLetra="verificarLetra" :jogar="jogar"/>
        <Final :jogarNovamente="jogarNovamente" :etapa="etapa" :winsorfail="winsorfail" v-if="etapa != 'jogo'"
         :texto="etapa === 'ganhador' ? 'Parabéns' : 'Você perdeu'" />
    </div>
</div>
</template>

<script>
import Forca from './Forca';
import Palavra from './Palavra';
import Teclado from './Teclado';
import Final from './Final';
export default{
    name: 'Jogo',
    props:{
        erros: Number,
        palavra: String,
        dica: String,
        verificarLetra: Function,
        etapa:String,
        letras:Array,
        jogar: Function,
        jogarNovamente: Function,
        winsorfail: Boolean,
    },
   components:{
       Forca,
       Palavra,
       Teclado,
       Final,
   }
}
</script>

<style scoped>

 .jogo{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      flex-direction: column;
  }
    
.imagem{
    padding-right: 5px;
}

.forcas{
    display:flex;
    align-items: center;
    justify-content: center;
}
h1{
    display:flex;
    align-items: center;
}

.forca_parte{
      animation:animar infinite 3s alternate-reverse;
}
@keyframes animar{
    to{
        transform: scale(1);
    }from{
        transform: scale(0.8);
    }
}
.forca_parte{
    display:flex;
    align-items: center;
    justify-content: center;
}
h1{
    display:flex;
    align-items: center;
    padding:9px 0;
    font-weight: bold;
    font-size: 41px;
    display:flex;
    align-items: center;
    text-shadow:rgba(10, 156, 214,0.5);
    color:rgb(81, 203, 251);
    letter-spacing: 5px;
}

    @media (max-width:900px){

    .forca_parte{     
        position:relative;
        top:17px;
     }
     
    }


    @media (max-width:450px){
     h1{
         font-size: 28px; 
     }

    .forca_parte{     
        position:relative;
        top:20px;
     }
     
    }

</style>
